import React, { Component } from 'react';
import './randomPodcast.css';

class RandomPodcast extends Component {
    constructor(props) {
        super(props);
        this.closeRandomPodcast = this.closeRandomPodcast.bind(this);
        this.state = {
            randomPodcast: this.props.randomPodcast,
            containerDisplay: "inherit"
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.randomPodcast !== prevProps.randomPodcast) {
            this.setState({
                randomPodcast: this.props.randomPodcast,
                containerDisplay: "block"
            })
        }
    }

    isNotEmpty(obj) {
        return Object.keys(obj).length !== 0;
    }

    createMarkup() {
        return ({
            __html: this.props.randomPodcast.description
        })
    }

    getProperDate() {
        var unix_ms = this.state.randomPodcast.pub_date_ms;
        const dateObject = new Date(unix_ms);
        return dateObject.toDateString();
    }

    getAudioLength() {
        var totalSeconds = this.state.randomPodcast.audio_length_sec;
        const min = Math.floor(totalSeconds / 60);
        var sec = totalSeconds - (min * 60)
        if (sec < 10)
            sec = "0" + sec
        return min + " minutes " + sec + " seconds"
    }

    closeRandomPodcast(e) {
        this.setState({
            containerDisplay: "none"
        })
    }

    render() {
        return (
            <div>
                {this.isNotEmpty(this.state.randomPodcast) &&
                    <div id="podcastContainer" className="podcastContainer" style={{ display: this.state.containerDisplay }}>
                        <div className="header">
                            <div className="smallText">
                                Listen to a random episode
                            </div>
                            <i className="bi bi-x" title="Close" onClick={this.closeRandomPodcast}></i>
                        </div>
                        <div className="podcastTitle">
                            {this.state.randomPodcast.podcast.title}
                        </div>
                        <div className="episodeTitle">
                            {this.state.randomPodcast.title}
                        </div>
                        <div className="podcastPublisher">
                            by {this.state.randomPodcast.podcast.publisher} on {this.getProperDate()}
                        </div>
                        <div className="dateTime">
                            <div>{this.getAudioLength()}</div> <a href={this.state.randomPodcast.audio} target="_blank" rel="noopener noreferrer"><i className="bi bi-headphones" title="Start Listening"></i></a>
                        </div>
                        {/* <div className="actionBar">
                            <i className="bi bi-heart-fill"></i>
                            <i className="bi bi-headphones"></i>
                            <i className="bi bi-bookmark-check-fill"></i>
                            <i className="bi bi-box-arrow-up-right"></i>
                        </div> */}
                        <div className="episodeDescription" dangerouslySetInnerHTML={this.createMarkup()}>
                        </div>
                    </div>
                }
            </div>
        )
    }
}


export default RandomPodcast;